import NidApp from "./api.js";

;( function( $, NidApp ) {

	$( function() {

		var productData        = [],
			$ii                = $( '.inspiration-images' ),
			$inspirationImages = $( '.inspiration-images article.inspiration-image' ),
			$modal             = $( '#ii-modal' ),
			numImages          = $inspirationImages.length,
			currImage,
			currProduct;

		$ii.on( 'click', 'a', function( e ) {
			if ( false === $(e.target).closest('article').hasClass('inspiration-image') ) {
				return;
			}

			e.preventDefault();
			var $link = $( e.currentTarget ),
				data  = $link.data(),
				isVideoPost,
				ajaxData;

			currImage   = +data.imgIndex;
			currProduct = +data.postId;
			isVideoPost = ( $link.hasClass( 'video-post' ) ) ? true : false;

			if ( typeof productData[ data.postId ] === 'undefined' ) {
				NidApp.showLoadingIcon();

				window.location.hash = data.postId;

				if ( true === isVideoPost ) {
					ajaxData = {
						action: 'nid_get_oembed_code',
						video_url: data.videoUrl
					};
				} else {
					ajaxData = {
						action  : 'nid_get_popup_titles',
						products: data.products,
						blog_id : data.blogId
					};
				}

				$.post( nordsjo.inspirationImageAjax, ajaxData ).done( function( result ) {

					NidApp.removeLoadingIcon();

					var ajaxResult = JSON.parse( result );

					if ( true === isVideoPost ) {
						productData[ data.postId ] = ajaxResult.html;
						renderInspirationVideo( data.header, ajaxResult.html );

					} else {
						productData[ data.postId ] = ajaxResult;
						renderInspirationImage( data.header, data.img, ajaxResult );

					}
				});

			} else {
				if ( true === isVideoPost ) {
					renderInspirationVideo( data.header, productData[ data.postId ] );

				} else {
					renderInspirationImage( data.header, data.img, productData[ data.postId ] );

				}

			}

		});


		/**
		 * Render the inspiration image in a modal dialog.
		 *
		 * @param {string} header      Modal header.
		 * @param {string} img         Image Src.
		 * @param {array}  productData Array of product objects.
		 */
		function renderInspirationImage( header, img, productData ) {
			var products  = renderProductIcons( productData ),
				$template = $( '#ii-modal-template' ).html(),
				hasProducts = ( products.length ) ? true : false,
				data,
				html;

			data = {
				header     : header,
				img        : img,
				products   : products,
				hasProducts: hasProducts,
				nid_fast_ajax: 1
			};
			html = _.template( $template )( data );
			$( '.ii-modal' ).removeClass( 'has-boards' );

			openModal( html );
		}


		/**
		 * Render an inspirations video.
		 *
		 * @param {string} header Modal header.
		 * @param {string} oEmbed oEmbed code.
		 */
		function renderInspirationVideo( header, oEmbed ) {
			var $template = $( '#ii-modal-video-template' ).html(),
				data      = {
					header: header,
					video : oEmbed
				},
				html = _.template( $template )( data );

			openModal( html );
		}


		/**
		 * Open the modal dialog.
		 *
		 * @param {string} html Modal dialog content.
		 */
		function openModal( html ) {
			$( '#ii-modal-body', $modal ).html( html );
			$( '.ii-img-no', $modal ).html( currImage );
			$( '.ii-img-total', $modal ).html( numImages );
			$modal.modal();

			$modal
				.on( 'click', 'a.bb-moodboard-link', function( e ) {
					$( this ).closest( '.ii-modal' ).removeClass( 'has-product-information' );
					// $( '.ii-modal-product-information' ).empty();
				})
				.off( 'click', 'a.bb-moodboard-link', showIiMoodboardList )
				.on( 'click', 'a.bb-moodboard-link', showIiMoodboardList );

			maybeDisablePagination();
		}


		/**
		 * Render the product popups.
		 *
		 * @param {array} products array of product objects.
		 *
		 * @return {string} Rendered HTML for products.
		 */
		function renderProductIcons( products ) {
			var productMarkup = '',
				$template     = $( '#ii-product-template' ).html();

			_.each( products, function( product ) {
				productMarkup += _.template( $template )( product );
			});

			return productMarkup;
		}


		/**
		 * Enable or disable pagination depending on position of current
		 * image in the array of images.
		 */
		function maybeDisablePagination() {
			if (
				$('body').hasClass( 'page-template-template-type-a' ) ||
				$('body').hasClass( 'page-template-template-type-b' )
			) {
				$( '.ii-mod-prev' ).addClass( 'disabled' );
				$( '.ii-mod-next' ).addClass( 'disabled' );

				return;
			}

			$( '.ii-mod-nav' ).removeClass( 'disabled' );

			if ( 1 === currImage ) {
				$( '.ii-mod-prev' ).addClass( 'disabled' );

			} else if ( numImages === currImage  ) {
				$( '.ii-mod-next' ).addClass( 'disabled' );

			}
		}


		/** Show inspiration images on click */
		function showInspirationImageProductPopup( e ) {
			e.preventDefault();

			var $this      = $( e.currentTarget ),
				product_id = $this.data( 'product-id' ),
				color_id   = $this.data( 'color-id' ),
				product;

			if ( $this.hasClass( 'loading' ) ) {
				return;
			}


			$( '.ii-product-trigger' ).removeClass( 'active' );
			$( this ).addClass( 'active' );

			NidApp.showLoadingIcon();
			product = NidApp.renderProductPopupInformation( product_id, color_id, 0 );
			$this.addClass( 'loading' );

			$.when( product ).done( function( result ) {
				var $productInformation = $( '.ii-modal-product-information' );

				$this.closest( '.ii-modal' ).addClass( 'has-product-information' );
				$( '.moodboards-inspiration-list' ).addClass( 'hide' );

				NidApp.removeLoadingIcon();
				if ( true === result.success ) {
					$this.removeClass( 'loading' );

					$productInformation
						.html( result.data )
						.on('click', 'button.wishlist-button', NidApp.addProductToCart )
						.on( 'click', 'a.moodboard-button', showIiMoodboardList );

					$( '#ii-modal' ).animate({ scrollTop: $productInformation.offset().top }, 750 );

				} else {
					NidApp.showMessage( result.data.message, 'error' );

				}
			});

		}


		function showIiMoodboardList( e ) {
			e.preventDefault();

			var $this    = $( e.currentTarget ),
				data     = $this.data(),
				$modal   = $this.closest( '.ii-modal' ),
				$list    = $( '.moodboard-selector', $modal ),
				$toggle  = $( '.new-modal-mb', $modal ),
				imageurl;

			if ( $modal.hasClass( 'has-product-information' ) ) {
				imageUrl = $( '.ii-image-container', $modal ).attr( 'data-image-src' );
			} else {
				imageUrl = $( '.ii-modal-image-container img' ).attr( 'src' );
			}

			if ( null === NidApp.$moodboards ) {
				if ( jQuery( 'body' ).hasClass( 'logged-in' ) ) {
					NidApp.showLoadingIcon();
					var mb = NidApp.jqueryPost({ action: 'ajax_get_moodboards' });

					$.when( mb ).done( function( result ) {
						NidApp.removeLoadingIcon();

						if ( true === result.success ) {
							NidApp.$moodboards = $( result.data );
							moodboardCallback( imageUrl, data );
						}

					});

				} else {
					NidApp.$moodboards = _.template( jQuery( '#moodboard-cookie-template' ).html() );
					moodboardCallback( imageUrl, data );
				}

			} else {
				moodboardCallback( imageUrl, data );

			}
		}



		/**
		 * Callback after fetching moodboard data.
		 *
		 * @param {string} moodboards HTML markup.
		 * @param {string} imageUrl   URL to image for moodboard.
		 * @param {object} data       Data object required for moodboard.
		 */
		function moodboardCallback( imageUrl, data ) {
			var $modal  = $( '.ii-modal' ),
				$list   = $( '.moodboard-selector', $modal ),
				$toggle = $( '.new-modal-mb', $modal ),
				$mbCont = $( '.moodboards-inspiration-list' );

			$modal
				.data( 'id', data.id )
				.data( 'type', data.type )
				.data( 'image-url', imageUrl )
				.find( '.add-to-mb-btn' )
					.remove()
					.end();

			$( '.ii-modal-product-information' ).empty();

			$( 'li.add-to-mb-btn', $list ).remove();
			$list.prepend( NidApp.$moodboards );
			$( 'span.check' ).css({ opacity: '0' });

			$toggle.addClass( 'hide' );
			$mbCont.removeClass( 'hide' );

			$( '#ii-modal' ).animate({ scrollTop: $mbCont.offset().top }, 750 );
		}


		/** Mark a product as added to the wishlist */
		function markWishlistProduct( productId ) {
			$( '.ii-product-trigger.active' ).addClass( 'wishlist-product' );

			_.each( productData[ currProduct ], function( product ) {
				if ( product.product == productId ) {
					product.wishlistProduct = 'wishlist-product';
				}
			});
		}


		/** Pagination */
		$( '.ii-modal' ).on( 'click', '.ii-mod-nav', function( e ) {
			var $link = $( e.currentTarget ),
				index = currImage;

			if ( $link.hasClass( 'disabled' ) ) return;

			if ( 'back' === $link.data( 'dir' ) ) {
				index = currImage - 2; // currImage starts at 1
			}

			$inspirationImages.eq( index ).find( 'a' ).trigger( 'click' );
		});


		/** Pagination with left/right keys */
		$( 'body' ).keydown( function( e ) {
			switch ( e.keyCode ) {
				case 37:
					$( '.ii-mod-prev' ).trigger( 'click' );
					break;

				case 39:
					$( '.ii-mod-next' ).trigger( 'click' );
					break;
			}
		});


		$( 'body' ).on( 'click', '.ii-product-trigger', showInspirationImageProductPopup );

		$( document ).on( 'addedToWishlist', function( e ) {
			markWishlistProduct( e.productId );
		});

	});

	$( window ).on('load', function() {
		var id = window.location.hash.replace('#','');
		$('a[data-post-id="'+id+'"]').click();
	});

}( jQuery, NidApp ));
